import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'da',
  DatePicker: {
    lang: {
      placeholder: 'Vælg dato',
      rangePlaceholder: [
        'Startdato',
        'Slutdato',
      ],
      locale: 'da_DK',
      today: 'I dag',
      now: 'Nu',
      backToToday: 'Gå til i dag',
      ok: 'Ok',
      clear: 'Ryd',
      month: 'Måned',
      year: 'År',
      timeSelect: 'Vælg tidspunkt',
      dateSelect: 'Vælg dato',
      monthSelect: 'Vælg måned',
      yearSelect: 'Vælg år',
      decadeSelect: 'Vælg årti',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Forrige måned (Page Up)',
      nextMonth: 'Næste måned (Page Down)',
      previousYear: 'Forrige år (Ctrl-venstre pil)',
      nextYear: 'Næste år (Ctrl-højre pil)',
      previousDecade: 'Forrige årti',
      nextDecade: 'Næste årti',
      previousCentury: 'Forrige århundrede',
      nextCentury: 'Næste århundrede',
    },
    timePickerLocale: {
      placeholder: 'Vælg tid',
      rangePlaceholder: [
        'Starttidspunkt',
        'Sluttidspunkt',
      ],
    },
  },
  TimePicker: {
    placeholder: 'Vælg tid',
    rangePlaceholder: [
      'Starttidspunkt',
      'Sluttidspunkt',
    ],
  },
  Calendar: {
    lang: {
      placeholder: 'Vælg dato',
      rangePlaceholder: [
        'Startdato',
        'Slutdato',
      ],
      locale: 'da_DK',
      today: 'I dag',
      now: 'Nu',
      backToToday: 'Gå til i dag',
      ok: 'Ok',
      clear: 'Ryd',
      month: 'Måned',
      year: 'År',
      timeSelect: 'Vælg tidspunkt',
      dateSelect: 'Vælg dato',
      monthSelect: 'Vælg måned',
      yearSelect: 'Vælg år',
      decadeSelect: 'Vælg årti',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Forrige måned (Page Up)',
      nextMonth: 'Næste måned (Page Down)',
      previousYear: 'Forrige år (Ctrl-venstre pil)',
      nextYear: 'Næste år (Ctrl-højre pil)',
      previousDecade: 'Forrige årti',
      nextDecade: 'Næste årti',
      previousCentury: 'Forrige århundrede',
      nextCentury: 'Næste århundrede',
    },
    timePickerLocale: {
      placeholder: 'Vælg tid',
      rangePlaceholder: [
        'Starttidspunkt',
        'Sluttidspunkt',
      ],
    },
  },
  Pagination: {
    items_per_page: '/ side',
    jump_to: 'Gå til',
    jump_to_confirm: 'bekræft',
    page: '',
    prev_page: 'Forrige Side',
    next_page: 'Næste Side',
    prev_5: 'Forrige 5 Sider',
    next_5: 'Næste 5 Sider',
    prev_3: 'Forrige 3 Sider',
    next_3: 'Næste 3 Sider',
  },
  Table: {
    filterTitle: 'Filtermenu',
    filterConfirm: 'OK',
    filterReset: 'Nulstil',
    filterEmptyText: 'Ingen filtre',
    emptyText: 'Ingen data',
    selectAll: 'Vælg alle',
    selectNone: 'Ryd alt data',
    selectInvert: 'Invertér valg',
    selectionAll: 'Vælg alt data',
    sortTitle: 'Sortér',
    expand: 'Udvid række',
    collapse: 'Flet række',
    triggerDesc: 'Klik for at sortere faldende',
    triggerAsc: 'Klik for at sortere stigende',
    cancelSort: 'Klik for at annullere sortering',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Afbryd',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Afbryd',
  },
  Transfer: {
    searchPlaceholder: 'Søg her',
    itemUnit: 'element',
    itemsUnit: 'elementer',
  },
  Upload: {
    uploading: 'Uploader...',
    removeFile: 'Fjern fil',
    uploadError: 'Fejl ved upload',
    previewFile: 'Forhåndsvisning',
    downloadFile: 'Download fil',
  },
  Empty: {
    description: 'Ingen data',
  },
};

export default localeValues;
